import { FETCH_COURSE_SPESIAL } from "store/types";

const initialState = [];

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_COURSE_SPESIAL:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
